import * as React from 'react'

import { observer } from 'mobx-react'

import AlertDialog from '~/client/src/shared/components/AlertDialog/AlertDialog'
import ConfirmDialog from '~/client/src/shared/components/ConfirmDialog/ConfirmDialog'
import type { DialogPortalContainer } from '~/client/src/shared/components/shadcn-ui/dialog'
import Localization from '~/client/src/shared/localization/LocalizationManager'

interface IProps {
  isShown: boolean
  isRecurring: boolean
  onContinue: () => void
  onCancel: () => void
  onApply?: () => void
  portalContainer?: DialogPortalContainer
}

const ClosuresConflictDialog: React.FC<IProps> = ({
  isShown,
  isRecurring,
  onContinue,
  onCancel,
  onApply,
  portalContainer,
}) => {
  const { translator } = Localization
  const title = translator.closuresConflictTitle

  if (isRecurring) {
    return (
      <ConfirmDialog
        isOpen={isShown}
        title={title}
        onCancelClicked={onCancel}
        onDoneClicked={onContinue}
        doneTitle={translator.continue}
        portalContainer={portalContainer}
      >
        <div className="tw:text-body-md tw:text-foreground">
          {translator.closuresConflictRecurringMessage}
        </div>
      </ConfirmDialog>
    )
  }

  return (
    <AlertDialog
      isOpen={isShown}
      title={title}
      onClose={onApply || onCancel}
      portalContainer={portalContainer}
    >
      {translator.closuresConflictMessage}
    </AlertDialog>
  )
}

export default observer(ClosuresConflictDialog)
